<template>
  <div class="signin">
    <div class="signin__content">
      <form
        class="signin__form container pa-0 grid-list-lg"
        @submit.prevent="submit"
        @keyup.enter="submit"
      >
        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">E-mail:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="email"
              class="form-input"
              :class="{ invalid: isInvalid('email') }"
              placeholder="Введите E-mail"
              v-model="$v.form.email.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div class="flex xs12 sm4 d-flex align-center">
            <div class="form-label">Пароль:</div>
          </div>
          <div class="flex xs12 sm8 form-fields">
            <input
              type="password"
              class="form-input"
              :class="{ invalid: isInvalid('password') }"
              placeholder="Введите пароль"
              v-model="$v.form.password.$model"
            />
          </div>
        </div>

        <div class="form-row layout row wrap">
          <div
            class="flex xs12 offset-sm4 sm8 form-fields text-xs-center text-sm-left"
          >
            <a href="" @click.prevent="recoverPassword">Забыли пароль?</a>
          </div>
        </div>

        <div class="form-row layout align-center justify-center">
          <div class="flex pt-3 text-xs-center">
            <AppBtn
              :loading="loading"
              round
              color="orange-grad"
              class="px-6"
              type="submit"
              @click="submit"
            >
              <span>Войти</span>
            </AppBtn>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getValidationMessage } from "@utils/validation-messages";
import { required, email } from "vuelidate/lib/validators";
import { requestAlert } from "@/services/common/showAlert";
import { asyncModal } from "@/components/ui/modal/";

import { mapActions, mapGetters } from "vuex";
import { openModal as openPasswordRecoverModal } from "./PasswordRecover";

const defaultForm = () => ({
  email: "",
  password: ""
});

const Signin = {
  name: "Signin",

  data: () => ({
    form: defaultForm(),
    loading: false,
    formErrors: {}
  }),

  validations: {
    form: {
      email: { required, email },
      password: { required }
    }
  },

  computed: {
    ...mapGetters("contest", ["isAuthenticated"])
  },

  methods: {
    ...mapActions("contest", ["login"]),

    async recoverPassword() {
      await openPasswordRecoverModal();
      this.$modals.close(this.isAuthenticated);
    },

    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      this.message = "";
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, message, data } = await this.login(this.form);

        if (success) {
          this.$modals.close(this.isAuthenticated);
        } else {
          console.log(data);
          requestAlert(message || undefined, data || []);
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default Signin;

export function openModal() {
  return asyncModal({
    name: "signin-modal",
    component: Signin,
    title: "Авторизация"
  });
}
</script>

<style lang="scss">
.signin {
  max-width: 400px;
  margin: 0 auto;
}
</style>
